import { useParams, useSearchParams } from "react-router-dom";
import RenCostEstimatorFlanders from "./RenCostEstimatorFlanders";
import RenCostEstimatorGirona from "./RenCostEstimatorGirona";

export default function RenCostEstimator(){
    const { region } = useParams();
    const [searchParams] = useSearchParams();
    const flow = searchParams.get("flow"); // "classic" or "guided"

    if (region === "flanders") return <RenCostEstimatorFlanders flow={flow} />;
    if (region === "girona")   return <RenCostEstimatorGirona flow={flow} />;
}
